export const SIDEBAR_SET = "set";
export const CLEAR_STATE = "CLEAR_STATE";
